import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RoleProvider } from "./RoleContext";
import routes from "./routes";
import LayoutWithSidebar from "./layouts/LayoutWithSidebar"; // Import Layout with Sidebar

const App = () => {
  return (
    <RoleProvider>
      <Router>
        <Routes>
          {routes.map(({ path, element, layout }, index) => {
            if (layout === "sidebar") {
              // Wrap route element with layout (sidebar) only if the layout is "sidebar"
              return (
                <Route
                  key={index}
                  path={path}
                  element={<LayoutWithSidebar>{element}</LayoutWithSidebar>}
                />
              );
            } else {
              // No layout for this route
              return <Route key={index} path={path} element={element} />;
            }
          })}
        </Routes>
      </Router>
    </RoleProvider>
  );
};

export default App;
